module.exports = __webpack_public_path__ + "assets/img/fr-82a6f52c.png";